module.exports = __webpack_public_path__ + "static/media/food-truck-party.d050bc43.svg";